export default "__VITE_ASSET__C1h8cfAF__"